import React from 'react';

export default function LoadingState({ step, percent = 0 }) {
  const circumference = 2 * Math.PI * 70;
  const offset = circumference - (percent / 100) * circumference;

  const getColor = () => {
    if (percent < 30) return '#3b82f6';
    if (percent < 60) return '#06b6d4';
    if (percent < 90) return '#8b5cf6';
    return '#10b981';
  };

  const color = getColor();

  return (
    <div className="loading-overlay-modern">
      {/* Animated background particles */}
      <div className="loading-particles">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className="loading-particle"
            style={{
              '--delay': `${i * 0.3}s`,
              '--x': `${20 + i * 12}%`,
              '--color': color,
            }}
          />
        ))}
      </div>

      {/* Circular progress */}
      <div className="loading-circle-container">
        <svg className="loading-circle-svg" viewBox="0 0 180 180" width="100%" height="100%">
          {/* Background track */}
          <circle
            cx="90" cy="90" r="70"
            fill="none"
            stroke="rgba(255,255,255,0.04)"
            strokeWidth="6"
          />
          {/* Animated glow ring */}
          <circle
            cx="90" cy="90" r="70"
            fill="none"
            stroke={color}
            strokeWidth="6"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            style={{
              transition: 'stroke-dashoffset 0.4s ease, stroke 0.5s ease',
              filter: `drop-shadow(0 0 8px ${color}50)`,
              transform: 'rotate(-90deg)',
              transformOrigin: 'center',
            }}
          />
          {/* Dot at the end of progress */}
          <circle
            cx="90"
            cy="90"
            r="4"
            fill={color}
            style={{
              transform: `rotate(${(percent / 100) * 360 - 90}deg)`,
              transformOrigin: 'center',
              transition: 'transform 0.4s ease',
              filter: `drop-shadow(0 0 6px ${color})`,
            }}
          >
            <animateTransform
              attributeName="transform"
              type="translate"
              values="0,-70"
              fill="freeze"
            />
          </circle>
        </svg>

        <div className="loading-percent-display">
          <span className="loading-percent-value" style={{ color }}>
            {percent}
          </span>
          <span className="loading-percent-symbol" style={{ color }}>%</span>
        </div>
      </div>

      {/* Status text */}
      <div className="loading-info">
        <div className="loading-title-modern">Analisando URL</div>

        {/* Progress bar */}
        <div className="loading-progress-bar-bg">
          <div
            className="loading-progress-bar-fill"
            style={{
              width: `${percent}%`,
              background: `linear-gradient(90deg, ${color}, ${color}cc)`,
              boxShadow: `0 0 16px ${color}40`,
            }}
          />
        </div>

        {/* Step text */}
        <div className="loading-step-modern">
          <span className="loading-step-dot" style={{ background: color, boxShadow: `0 0 8px ${color}` }} />
          {step || 'Inicializando...'}
        </div>

        {/* Scanning modules */}
        <div className="loading-modules">
          {['DNS', 'SSL', 'GeoIP', 'WAF', 'URL', 'Phishing', 'Blacklist', 'Heurística'].map((mod, i) => {
            const modPercent = (i + 1) * 13;
            const isActive = percent >= modPercent - 8;
            const isDone = percent >= modPercent + 8;
            return (
              <div
                key={mod}
                className={`loading-module ${isDone ? 'done' : isActive ? 'active' : ''}`}
                style={{
                  '--accent': color,
                  transitionDelay: `${i * 0.05}s`,
                }}
              >
                <span className="loading-module-icon">
                  {isDone ? '✓' : isActive ? '⟳' : '○'}
                </span>
                {mod}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
